import { getStores } from '@littlebird/sdk';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { getDefaultMeetingTab } from '@/features/meetings/meeting-mapper';
import { meetingApis } from '@/features/meetings/meetings.query';
import { meetingStore } from '@/features/meetings/meetings.state';
import { logError } from '@/lib/errorLogging';
import { SearchFocusSchema } from '@/lib/search-focus';

const MeetingSearchSchema = SearchFocusSchema.extend({
  tab: z.enum(['notes', 'summary', 'transcript', 'assist']).optional(),
  openPrep: z
    .literal([true, 'true', '1'])
    .transform(() => true as const)
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute('/_authenticated/meetings/$meetingId')({
  validateSearch: MeetingSearchSchema.passthrough().parse,
  // a pendingComponent gives this match its own Suspense boundary, so a
  // pending leaf never bubbles up to the _authenticated layout's splash
  pendingComponent: () => null,
  beforeLoad({ params: { meetingId }, search }) {
    if (search.tab) return;
    throw redirect({
      to: '/meetings/$meetingId',
      params: { meetingId },
      search: {
        ...search,
        tab: getDefaultMeetingTab(
          getStores().meetings.get(meetingId)?.externalSource
        ),
      },
      replace: true,
    });
  },
  onEnter({ params: { meetingId } }) {
    meetingStore.meetingInViewId = meetingId;
    getStores().meetings.get(meetingId)?.markNotificationViewed();
  },
  onLeave({ params: { meetingId } }) {
    meetingStore.meetingInViewId = undefined;
    void meetingApis
      .reindexMeetingSearch(meetingId)
      .catch((error) => logError(error, 'unable to reindex meeting search'));
  },
});
